import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Spin from 'components/ui/Spin'
import UserList from './UserList/UserList'
import {
  getUsers,
  isFetching,
  fetchUsers,
  deleteUser
} from 'store/userReducer'

class UserListContainer extends Component {
  componentDidMount() {
    this.props.fetchUsers()
  }

  render() {
    const { isFetching, users, match, handleDelete } = this.props

    if (isFetching) {
      return <Spin />
    } else {
      return <UserList users={users} match={match} onDelete={handleDelete} />
    }
  }
}

const mapStateToProps = state => ({
  users: getUsers(state),
  isFetching: isFetching(state)
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    fetchUsers,
    handleDelete: id => deleteUser(id)
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(UserListContainer)



// WEBPACK FOOTER //
// ./src/features/user/UserListContainer/UserListContainer.js